import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMemo } from "react";
import { resolveStationRouteSlug } from "../../../utils/stationFlowStorage";
import { bgImages } from "../../../constants";
import StationThemeLayout from "../../../layouts/StationThemeLayout";
import CartoonContinueBtn from "../../../assets/img/cartoon/continue-btn.png";

const SelectPeopleCartoon = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { slug } = useParams();

  const stationData = useMemo(() => {
    const selectedRaw = localStorage.getItem("selectedStation");
    const fromSelected = selectedRaw ? JSON.parse(selectedRaw) : null;
    const fromStorage = JSON.parse(localStorage.getItem("stationData") || "{}");
    return fromSelected || fromStorage;
  }, [location.state]);

  const selectedArt = useMemo(() => {
    try {
      const fromNav = (
        location.state as {
          selectedArt?: {
            name?: string;
            inner_bg_image?: string | null;
            background_image?: string | null;
          };
        } | null
      )?.selectedArt;
      if (fromNav?.name) return fromNav;
      const raw = localStorage.getItem("selectedAiSelfieArt");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, [location.state]);

  const routeSlug = resolveStationRouteSlug(stationData, slug, selectedArt);

  const cartoonBackground =
    selectedArt?.inner_bg_image?.trim() ||
    selectedArt?.background_image?.trim() ||
    bgImages.cartoon;

  const goNext = () => {
    navigate(`/${routeSlug}/choose-option`, {
      state: {
        stationData,
        selectedArt,
      },
    });
  };

  return (
    <StationThemeLayout
      className="chooseOptionSection p-0 selectPeopleCartoonTheme"
      station={stationData}
      showStationLogo
      backgroundOverride={cartoonBackground}
      onBack={() => navigate(`/${routeSlug}/idle`)}
    >
      <div className="selectPeopleSection">
        <div className="selectPeopleContent">
          <div className="selectPeopleNotice selectPeopleNotice--cartoon mt-5" role="note">
            <div className="selectPeopleNoticeHeading">
              CREATE EITHER SOLO OR GROUP
            </div>
          </div>

          <div className="cartoonPeopleChoiceColumn">

            <div className="cartoonPeopleChoiceText">
              You can create a 90's Cartoon of yourself or with <br /> Friends and Family
            </div>

            <button
              type="button"
              className="cartoonPeopleNextBtn"
              onClick={goNext}
              aria-label="Next"
            >
              <img
                src={CartoonContinueBtn}
                alt="Continue"
                className="cartoonPeopleNextBtnImg"
                draggable={false}
              />
            </button>
          </div>
        </div>
      </div>
    </StationThemeLayout>
  );
};

export default SelectPeopleCartoon;
